export default "__VITE_ASSET__9da1040b__"